<template>
  <v-app ref="app">
    <v-row v-if="!isLoading && accessError" cols="12" justify="center">
      <v-alert type="error" class="mx-auto col-6" style="height: 60px; margin-top: 50px;">
        <div style="margin-top: -5px;">
					<span>{{ $t('app.access_error', [username]) }}</span>
					<v-btn color="#222" @click="logout" text float="right">{{ $t('app.close_session') }}</v-btn>
				</div>
      </v-alert>
    </v-row>

    <v-navigation-drawer v-model="drawer" v-if="!isLoading && !accessError" clipped app>
      <v-list nav dense>
        <v-list-item
          :style="menuItemIsCurrentModule(item) ? 'background-color: #C3271A; border-radius: 5px;' : ''"
          @click="showModule(item.module, { moduleId: item.moduleId })"
          v-for="item in userMenu"
          :key="item.title"
          link
        >
          <v-list-item-icon>
            <v-icon :style="menuItemIsCurrentModule(item) ? 'color: white;' : 'color: black;'">
							{{ item.icon }}
						</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title
              :style="menuItemIsCurrentModule(item) ? 'color: white;' : 'color: black;'"
            >{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app clipped-left v-if="!isLoading && !accessError" :elevation="3">
      <!--<v-app-bar-nav-icon class="white--text" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>-->

      <v-toolbar-items>
        <img src="@/assets/logo-humanway.png" style="width: 75px; height: 48px;" class="ml-4 mt-2" />
      </v-toolbar-items>

      <v-spacer></v-spacer>

      <span class="white--text hidden-sm-and-down" style="margin-right: 10px; font-size: .9em;"> {{ username }} </span>

      <v-menu bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="bg-btn" icon v-bind="attrs" v-on="on">
            <v-icon class="white--text">mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item @click="logout()">
            <v-list-item-title>{{ $t('app.close_session') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!--<v-row v-if="isLoading" cols="12" justify="center" style="margin-top:60px">
      <v-col class="mx-auto" cols="12">
        <v-skeleton-loader type="card" class="mx-auto" max-width="90%" />
      </v-col>
    </v-row>-->

    <!-- Sizes your content based upon application components -->
    <v-container fluid class="pa-0" v-if="!isLoading && !accessError">
      <!-- Provides the application the proper gutter -->
      <v-container fluid class="pb-0" :style="'background-color: #f8f8f8; width: 100%; height: ' + (currentModule==='HomeModule'?'100%':'100vh') + ';'">
        <!-- If using vue-router -->
        <!--<keep-alive>
				<router-view :drawer="drawer" @update-menu="updateMenu($event)" @show-alert="doShowAlert($event)"></router-view>
        </keep-alive>-->

        <HomeModule
          v-if="currentModule === 'HomeModule'"
          ref="HomeModule"
          :drawer="drawer"
          @show-alert="doShowAlert($event)"
        />
        <EMModule
          v-if="currentModule === 'EMModule'"
          ref="EMModule"
          :drawer="drawer" 
					@refresh="refreshModule" 
          @show-alert="doShowAlert($event)"
        />
        <DialogManager ref="DialogManager" @refresh="refreshModule" />
      </v-container>
    </v-container>

    <v-footer app class="pa-0">
      <!-- -->
    </v-footer>

    <v-snackbar v-model="showAlert" :timeout="alertTimeout" :color="alertColor">
      <span style="color: #ffffff;">{{ alertText }}</span>
      <v-btn text @click="showAlert=false">
        <span style="color: #ffffff;">{{ 'Cerrar' }}</span>
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
// eslint-disable-next-line no-unused-vars
//import styles from './assets/App.css'
import BaseModule from "./components/common/BaseModule.js";
import HomeModule from "./components/modules/HomeModule.vue";
import EMModule from "./components/modules/EMModule.vue";
import DialogManager from "./components/modules/DialogManager.vue";
import { EventBus } from "./components/util/event-bus.js";
import { Constants } from './components/common/Constants.js';

export default {
  name: "App",
  mixins: [BaseModule],
  components: {
    HomeModule,
    DialogManager,
    EMModule,
  },
  data() {
    return {
			root: null,
      drawer: true,
      isLoading: false,
      //accessError: false,
      right: null,
      menu: [
        {
          title: this.$t("menu.home"),
          icon: "mdi-home-outline",
          module: "HomeModule",
          moduleId: Constants.MODULE_HOME,
        },
        {
          title: this.$t("menu.assessments"),
          icon: "mdi-calendar-blank",
          module: "EMModule",
          moduleId: Constants.MODULE_ASSESSMENTS,
        },
        {
          title: this.$t("menu.users"),
          icon: "mdi-account-group-outline",
          module: "EMModule",
          moduleId: Constants.MODULE_USERS,
        },
        {
          title: this.$t("menu.configs"),
          icon: "mdi-cog-outline",
          module: "EMModule",
          moduleId: Constants.MODULE_CONFIGS,
        },
      ],
      currentModuleId: 0,
      currentModule: "HomeModule",
      showAlert: false,
      alertColor: "error",
      alertText: "",
      alertTimeout: 6000,
    };
  },
  computed: {
		sessionUser() {
			return this.$store.state.humanway.sessionUser;
		},
    username() {
      return this.$store.state.humanway.profile.username;
    },
    accessError() {
      return !this.$store.state.humanway.sessionUser || this.$store.state.humanway.sessionUser.enabled === false;
    },
		userMenu() {
			if (!this.sessionUser) {
				return [];
			}

			/*if (this.sessionUser.profileId !== this.constants.PROFILE_ADMIN) {
				return this.menu.slice(0, 2);
			}*/

			return this.menu;
		}
  },
  mounted() {
    this.root = document.documentElement;

    let me = this;

    /*this.$nextTick(() => {
      window.$vueBridge = me;
      me.$refs.app.$el.firstChild.style.minHeight="100%";
    });*/

    EventBus.$on("widget-data-click", (payload) => {
      if (payload.mode === "VUEDIALOG" && me.$refs.DialogManager.processEvent) {
        me.$refs.DialogManager.processEvent(
          payload.mode,
          payload.type,
          payload.action,
          payload.payload
        );
      }
    });
  },
  methods: {
		menuItemIsCurrentModule(item) {
			return item.module === this.currentModule && item.moduleId === this.currentModuleId;
		},
    refreshModule() {
      if (this.currentModule &&
        this.$refs[this.currentModule] &&
        this.$refs[this.currentModule].refreshModule) {
        this.$refs[this.currentModule].refreshModule();
      }
    },
    doShowAlert: function (payload) {
      this.alertText = payload.text;
      this.alertColor = payload.color;
      //this.alertTimeout = payload.timeout;
      this.showAlert = true;
    },
    showModule: function (module, payload) {
      let me = this;

      me.currentModule = module;
      me.currentModuleId = payload.moduleId;

      this.$nextTick(() => {
        if (me.$refs[me.currentModule].onReveal) {
          me.$refs[module].onReveal(payload);
        }
      });
    },
    logout: function () {
      // eslint-disable-next-line no-undef
      kc_logout();
    },
  },
	watch: {
    drawer: {
      handler: function() {
        // because we are using this handler immideatly we need to wait for data changes using nextTick.
        this.$nextTick(() => {
          this.root.style.setProperty("--drawer", this.drawer ? "200px" : "0");
        });
      },
      immediate: true
    }
  }
};
</script>
